<template>
  <p class="gs-analytics-footnote">
    Dates use US Eastern reporting days. Daily unique viewers are deduplicated per video and day,
    then summed; the same browser can count again on another day or video. Play rate is plays ÷
    player loads. Completion rate is finishes ÷ plays. Watch time excludes seeking and buffering.
    Editor previews are excluded. Reports refresh after collection, normally within two minutes.
  </p>
</template>

<script>
export default {
  name: 'AnalyticsFootnote',
};
</script>

<style scoped>
.gs-analytics-footnote {
  margin: 0;
  color: var(--gs-muted-foreground);
  font-size: 12px;
  line-height: 1.5;
}
</style>
